<template>
  <div
    class="resume-page"
    :class="{ _has_error: !!error }"
  >
    <BasePreloader v-if="pending"/>
    <template v-if="resume">
      <ResumeFixedPanel
        v-if="!isOwnResume && !isModeratorRoute && !isPartnerRoute"
        :hasInteraction="hasInteraction"
        :hasInteractionFromAnotherEmployer="hasInteractionFromAnotherEmployer"
        :isInvited="isInvited"
        :isRejected="isRejected"
        :responseData="responseData"
        @accept="accept()"
        @decline="decline()"
      />
      <div ref="main-section"
           class="resume-page__main-section">
        <ResumeMain
          :shared-resume="sharedResume"
          :isOwnResume="isOwnResume"
          :responseData="responseData"
          :data="$get(questionnaireData, 'first_block')"
          :vacancy="vacancy"
          :hasInteraction="hasInteraction"
          :hasInteractionFromAnotherEmployer="hasInteractionFromAnotherEmployer"
          :isInvited="isInvited"
          :isRejected="isRejected"
          :is-moderator-route="isModeratorRoute"
          :is-partner-route="isPartnerRoute"
          @accept="accept()"
          @decline="decline()"
          @update-note="updateResponseData({ resume: { global_note: $event } })"
        />
      </div>
      <div class="resume-page__content-sections">
        <div class="resume-page__content-sections-left">

          <ResumeInfoSectionBasis v-if="infoBasis"
                                  :isOpenOnMobile="isOpenOnMobile"
                                  :isToggleHidden="isDesktop"
                                  :item="infoBasis"
                                  :resume="resume"
                                  class="_head-border"/>
          <ResumeInfoAgencyQuestionnaire v-if="infoAgentQuestionnaire"
                                         :isOpenOnMobile="isOpenOnMobile"
                                         :isToggleHidden="isDesktop"
                                         :items="infoAgentQuestionnaire"
                                         class="_head-border"/>
        </div>
        <div class="resume-page__content-sections-right">
          <ResumeInfoSectionAdditional v-if="infoAdditional"
                                       :isOpenOnMobile="isOpenOnMobile"
                                       :isToggleHidden="isDesktop"
                                       :item="infoAdditional"
                                       :resume="resume"
                                       class="_head-border"/>

          <ResumeInfoSectionInteraction v-if="interactionData && (isOurEmployer || isModerator)"
                                        :data="interactionData"
                                        :isOpenOnMobile="isOpenOnMobile"
                                        :isToggleHidden="isDesktop"
                                        class="resume-page__section  _head-border"/>
          <ResumeDownloadedDocuments v-if="documents && documents.length"
                                     :isToggleHidden="isDesktop"
                                     :isOpenOnMobile="isOpenOnMobile"
                                     :documents="documents"
                                     :viewedPassportPages="resume.viewed_passport_pages"
                                     :archiveNames="archiveNames"
                                     :resumeId="resumeId"
                                     :mainInfo="$get(questionnaireData, 'first_block')"
                                     class="resume-page__section  _head-border"/>
          <ResumeActiveResponses v-if="activeResponses.count && !sharedResume"
                                 :isOpenOnMobile="isOpenOnMobile"
                                 :activeResponses="activeResponses"
                                 class="resume-page__section"/>

          <ResumeUserActionsSection v-if="userStories && (isOurEmployer || isModerator)"
                                    :isOpenOnMobile="isOpenOnMobile"
                                    :isToggleHidden="isDesktop"
                                    :userStories="userStories"/>
          <ResumePrimarySelectionData v-if="infoPrimaryQuestionnaire && (isOurEmployer || !isEmployer || sharedResume)"
                                      :isOpenOnMobile="isOpenOnMobile"
                                      :isToggleHidden="isDesktop"
                                      :items="infoPrimaryQuestionnaire"
                                      class="_head-border"/>
          <!-- <ResumeVideoInterview :isOpenOnMobile="isOpenOnMobile"/> -->
        </div>
      </div>

      <ResumeCardNavigation v-if="nextResume || prevResume"
                            :next-resume="nextResume"
                            :prev-resume="prevResume"
      />
    </template>

    <!-- IF SOMETHING WENT WRONG -->
    <ErrorView v-else-if="error"
               :code="error.code"
               :message="error.message"/>
  </div>
</template>

<script>
  import {mapState, mapGetters} from 'vuex';
  import {http} from '@/axios';
  import windowSizeMixin from '@/mixins/windowSizeMixin';
  import {isEmpty, merge} from 'lodash';
  import {WINDOW_SIZE_MD} from '@/constants/windowSizes';

  import ErrorView from '@/components/ErrorView'

  import ResumeMain from '@/components/resumeView/ResumeMain.vue';
  // import ResumeInfoSection from '@//components/resumeView/ResumeInfoSection';
  import ResumeInfoSectionBasis from '@//components/resumeView/ResumeInfoSectionBasis';
  import ResumeInfoSectionAdditional from '@//components/resumeView/ResumeInfoSectionAdditional';
  import ResumeInfoSectionInteraction from '@//components/resumeView/ResumeInfoSectionInteraction';
  import ResumePrimarySelectionData from '@//components/resumeView/ResumePrimarySelectionData';
  import ResumeInfoAgencyQuestionnaire from '@//components/resumeView/ResumeInfoAgencyQuestionnaire';
  import ResumeDownloadedDocuments from '@/components/resumeView/ResumeDownloadedDocuments.vue';
  import ResumeActiveResponses from '@/components/resumeView/ResumeActiveResponses.vue';
  import ResumeUserActionsSection from '@/components/resumeView/ResumeUserActionsSection';
  // import ResumeVideoInterview from '@/components/resumeView/ResumeVideoInterview.vue';
  import ResumeCardNavigation from '@/components/resumeView/ResumeCardNavigation';
  import ResumeFixedPanel from '@/components/resumeView/ResumeFixedPanel';


  export default {
    name: 'AccountResumeCardPage',
    mixins: [windowSizeMixin],

    components: {
      ErrorView,
      ResumeCardNavigation,
      // ResumeInfoSection,
      ResumeInfoSectionBasis,
      ResumeInfoSectionAdditional,
      ResumeInfoSectionInteraction,
      ResumePrimarySelectionData,
      ResumeInfoAgencyQuestionnaire,
      ResumeMain,
      ResumeDownloadedDocuments,
      ResumeActiveResponses,
      ResumeUserActionsSection,
      ResumeFixedPanel,
      // ResumeVideoInterview,
    },

    props: {
      sharedResume: {
        type: Boolean,
        default: false,
      },
      loadPath: {
        type: String,
        default: null,
      },
    },

    data() {
      return {
        WINDOW_SIZE_MD,
        responseData: null,
        error: null,
        pending: false,
        pendingAction: false
      };
    },

    computed: {
      ...mapState('user', {
        loaded: 'loaded',
        resumeOwn: 'resume',
      }),
      ...mapGetters('user', [
        'isEmployer',
        'isEmployee',
        'isOurEmployer',
        'isModerator',
      ]),
      isOwnResume() {
        const noOwnResumeRoutes = ['received-resume'];
        const noOwnResumeRoutesWithDouble = noOwnResumeRoutes.concat(noOwnResumeRoutes.map(r => r + '-double'));
        if (noOwnResumeRoutesWithDouble.includes(this.$route.name)) return false;
        return !!this.resumeOwn
      },
      resume() {
        return this.isOwnResume ? this.resumeOwn : this.$get(this.responseData, 'resume');
      },
      resumeId() {
        return parseFloat(this.$route.params.resumeId || this.responseData?.sent_resume_id)
      },
      questionnaireData() {
        return this.$get(this.resume, 'parsed_questionaire_data');
      },
      infoBasis() {
        return this.$get(this.questionnaireData, 'data.basic_info')
      },
      infoAdditional() {
        return this.$get(this.questionnaireData, 'data.additional_info')
      },
      infoAgentQuestionnaire() {
        return this.$get(this.resume, 'agent_questionnaire')
      },
      infoPrimaryQuestionnaire() {
        return this.$get(this.resume, 'primary_questionnaire')
      },
      interactionData() {
        return this.$get(this.resume, 'interaction')
        // return {
        //   main: this.$get(this.questionnaireData, 'data.additional_info[0].items'),
        //   personBodyCharacteristics: {
        //     height: 'height',
        //     weight: 'weight',
        //     clothing_size: 'clothing_size',
        //     waist: 'waist',
        //     shoe_size: 'shoe_size',
        //   },
        //   documents: [{
        //     title: 'Страховка',
        //     files: [{
        //       id: 1,
        //       ext: "jpg",
        //       name: "58228782671e8379084854e3f1f36878",
        //       name_for_download: "58228782671e8379084854e3f1f36878.jpg",
        //       path: "https://dev-api.jobian.com/storage/customer_files/April2021/eafe72eb02d05b8b9f01b379879fede7.jpg",
        //     }, {
        //       id: 2,
        //       ext: "jpg",
        //       name: "58228782671e8379084854e3f1f36878",
        //       name_for_download: "58228782671e8379084854e3f1f368782.jpg",
        //       path: "https://dev-api.jobian.com/storage/customer_files/April2021/eafe72eb02d05b8b9f01b379879fede7.jpg",
        //     }]
        //   }, {
        //     title: 'Билет',
        //     files: [{
        //       id: 3,
        //       ext: "jpg",
        //       name: "58228782671e8379084854e3f1f36878",
        //       name_for_download: "58228782671e8379084854e3f1f3687832.jpg",
        //       path: "https://dev-api.jobian.com/storage/customer_files/April2021/eafe72eb02d05b8b9f01b379879fede7.jpg",
        //     }]
        //   }]
        // }
      },
      vacancy() {
        return this.$get(this.responseData, 'vacancy');
      },
      activeResponses() {
        return this.$get(this.resume, 'active_responses');
      },
      documents() {
        return this.$get(this.questionnaireData, 'passport');
      },
      archiveNames() {
        return this.$get(this.responseData, 'archive_names');
      },
      userStories() {
        return this.$get(this.resume, 'user_story');
      },
      prevResume() {
        const resume = this.$get(this.responseData, 'prev_resume')
        return isEmpty(resume) ? null : resume
      },
      nextResume() {
        const resume = this.$get(this.responseData, 'next_resume')
        return isEmpty(resume) ? null : resume
      },
      isInvited() {
        return this.$get(this.responseData, 'is_invited')
      },
      isRejected() {
        return this.$get(this.responseData, 'is_rejected')
      },
      hasInteraction() {
        return this.isOwnResume ? this.$store.getters['user/hasInteraction'] : !!this.$get(this.responseData, 'interaction')
      },
      hasInteractionFromAnotherEmployer() {
        return !!this.$get(this.responseData, 'have_interaction_from_another_employer')
      },

      isOpenOnMobile() {
        return this.windowSizeMixin.width > this.WINDOW_SIZE_MD;
      },
      isDesktop() {
        return this.windowSizeMixin.width > this.WINDOW_SIZE_MD;
      },
      isModeratorRoute() {
        return this.isRouteNameMixin('account-moderator-candidates-resume')
      },
      isPartnerRoute() {
        return this.isRouteNameMixin('account-partner-resumes-base-resume')
      },
    },

    methods: {
      load() {
        if ((!this.loaded || this.isOwnResume) && !this.sharedResume) return

        this.pending = true;
        this.error = null;

        const path = this.loadPath || this.getDefaultLoadPath();

        if (!path) return this.$vModal.open('warning', { message: 'Something went wrong on load resume' });

        return http.get(path).then(({data}) => {
          this.responseData = data.data
        }).catch((error) => {
          this.error = {
            code: error.response.status,
            message: error.response.data && error.response.data.message || error.message
          }
        }).finally(() => {
          this.pending = false;
        });
      },
      getDefaultLoadPath() {
        return this.isModeratorRoute
          ? `/api/backoffice/resumes/${this.resumeId}/profile`
          : this.isPartnerRoute ? `/api/cabinet/agent/resume/${this.resumeId}`
            : `/api/new-resume/get/${this.resumeId}`;
      },

      updateResponseData(newDataDeep) {
        this.responseData = merge({}, this.responseData, newDataDeep);
      },

      accept() {
        this.$vModal.open('take-to-work', {
          resumeId: this.resumeId,
          vacancyId: +this.vacancy.ID,
          sharedResume: this.sharedResume,
          callBack: () => {
            this.responseData.is_invited = true
          }
        })
      },

      decline() {
        this.$vModal.open('reject-candidate', {
          resumeId: this.resumeId,
          sharedResume: this.sharedResume,
        })
      }
    },

    created() {
      this.load();
    },

    watch: {
      $route() {
        this.load();
      },
      loaded() {
        this.load();
      }
    }
  };
</script>
